import { render } from "./SpecificationOptions.vue?vue&type=template&id=849d6772"
import script from "./SpecificationOptions.vue?vue&type=script&lang=js"
export * from "./SpecificationOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__